import { useCallback, useEffect, useState } from 'react';

import { copyTextToClipboard } from '@zapier/common-utils';

type UseCopyToClipboardReturn = [boolean, () => void];

function useCopyToClipboard(value: string): UseCopyToClipboardReturn {
  // A piece of state to keep track of if the user has copied the text to clipboard.
  const [didCopy, setDidCopy] = useState(false);

  const handleCopyText = useCallback(() => {
    copyTextToClipboard(value);
    setDidCopy(true);
  }, [value]);

  useEffect(() => {
    if (didCopy === true) {
      const setDidCopyTimeout = setTimeout(() => {
        setDidCopy(false);
      }, 3000);

      return () => clearTimeout(setDidCopyTimeout);
    }

    return () => undefined;
  }, [didCopy]);

  return [didCopy, handleCopyText];
}

export default useCopyToClipboard;
